import { makeSetValueReducer } from 'uf/base/reducerFactories';
import { SET_DEBUG_FLAG } from 'uf/debug/ActionTypes';

const flags = makeSetValueReducer(SET_DEBUG_FLAG);

export default flags;
